<template>
  <e-dialog
    :dialog-title="title"
    :center-dialog-visible="visible"
    :popup-width="'1200px'"
    :destroy-close="true"
    :modal-append-to-body="true"
    :show-btn="itemData.type !== 'detail' ? true : false"
    @resetPopupData="onCancel"
    @submitPopupData="onOk"
  >
    <carbonfootprint-certificate
      v-if="itemData.key === 'carbonCertList'"
      :ref="itemData.ref"
      :certificate="[itemData]"
      :type="itemData.type"
      component-type="single"
    />
    <carbonfootprint-report
      v-if="itemData.key === 'carbonReportList'"
      :ref="itemData.ref"
      :report="[itemData]"
      :type="itemData.type"
      component-type="single"
    />
    <gree-factory-evalution
      v-if="itemData.key === 'factory'"
      :ref="itemData.ref"
      :factory="[itemData]"
      :type="itemData.type"
      component-type="single"
    />
    <supply-chain-list
      v-if="itemData.key === 'supplyChain'"
      :ref="itemData.ref"
      :supply-chain="[itemData]"
      :type="itemData.type"
      component-type="single"
    />
    <green-product-list
      v-if="itemData.key === 'productList'"
      :ref="itemData.ref"
      :product-list="[itemData]"
      :type="itemData.type"
      component-type="single"
    />
    <other-list
      v-if="itemData.key === 'other'"
      :ref="itemData.ref"
      :other="[itemData]"
      :type="itemData.type"
      component-type="single"
    />
  </e-dialog>
</template>

<script>
import eDialog from '@/modules/projectA/components/common/e-dialog.vue';
import CarbonfootprintCertificate from './components/carbonfootprintCertificate';
import CarbonfootprintReport from './components/carbonfootprintReport';
import greeFactoryEvalution from './components/greeFactoryEvalution';
import supplyChainList from './components/supplyChain';
import greenProductList from './components/greenProductList';
import otherList from './components/otherList';

export default {
  components: {
    eDialog,
    CarbonfootprintCertificate,
    CarbonfootprintReport,
    greeFactoryEvalution,
    supplyChainList,
    greenProductList,
    otherList,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    itemData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },

  methods: {
    onCancel() {
      this.$emit('update:visible', false);
    },
    onOk() {
      const { ref } = this.itemData;
      this.$refs[ref].submit().then((res) => {
        this.$emit('submitPopupData', {
          success: res.success,
          data: res.data[0] || {},
          id: this.itemData.id,
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__footer {
  padding: 20px;
}
::v-deep .el-dialog__body {
  height: 312px;
  overflow-y: auto;
  padding-bottom: 0;
}
.tree-box {
  width: 100%;
  height: 250px;
  box-sizing: border-box;
  padding: 2px 0;
  overflow-y: auto;
  margin-top: 10px;
}
</style>
